import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChatComponent } from './components/chat/chat.component';
import { HomeComponent } from './components/home/home.component';
import { WorkChatComponent } from './components/work-chat/work-chat.component';
import { AuthGuard } from './common/auth-guard';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'general-chat', component: ChatComponent },
  { path: 'work-chat', component: WorkChatComponent, canActivate: [AuthGuard] },
  {
    path: 'dentbox-work-request-list',
    loadChildren: () => import('./modules/work-request-list/work-request-list.module').then(m => m.WorkRequestListModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
  },
  // Backward-compatible redirects: existing navigate(['unauthorized']) and
  // [routerLink]="['/forgot']" / ['/dsa-login'] / ['/reset'] calls keep
  // working now that the components live under the lazy `auth` module.
  { path: 'unauthorized', redirectTo: 'auth/unauthorized' },
  { path: 'dsa-login', redirectTo: 'auth/dsa-login' },
  { path: 'forgot', redirectTo: 'auth/forgot' },
  { path: 'reset', redirectTo: 'auth/reset' }
];

@NgModule({
  exports: [RouterModule],
  imports: [
    RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })
  ],
  declarations: []
})
export class AppRoutingModule {

}
